/**
 * 文章/新闻相关接口
 */
import request from './request'

/**
 * 获取文章详情
 * @param {object} params - { id }
 */
export function getNewsContent(params) {
  return request.post('/api/news/detail', params)
}

/**
 * 搜索新闻
 * @param {object} params - { query, pageNum, pageSize }
 */
export function searchNews(params) {
  return request.post('/api/news/search', params)
}

/**
 * 获取首页新闻列表
 * @param {object} params - { categoryIdList }
 */
export function getNewsList(params) {
  return request.post('/api/index/getNewsList', params)
}

/**
 * 获取频道新闻列表（L2）
 * @param {object} params - { categoryId, isRecommended, pageNum, pageSize, excludeNewsIdList }
 */
export function getNewsListL2(params) {
  return request.post('/api/news/listL2', params)
}

/**
 * 检测企业文章标题是否重复
 * @param {object} params - { title }
 */
export function checkCompanyTitle(params) {
  return request.post('/api/company/news/checkTitle', params)
}

/**
 * 检测个人文章标题是否重复
 * @param {object} params - { title }
 */
export function checkMemberTitle(params) {
  return request.post('/api/member/news/checkTitle', params)
}

/**
 * 企业账号提交文章审核
 * @param {object} params - 文章参数
 */
export function submitCompanyAudit(params) {
  return request.post('/api/company/news/submitAudit', params)
}

/**
 * 个人账号提交文章审核
 * @param {object} params - 文章参数
 */
export function submitMemberAudit(params) {
  return request.post('/api/member/news/submitAudit', params)
}

/**
 * 获取企业文章列表
 * @param {object} params - { queryStatus, pageNum, pageSize }
 */
export function getCompanyNewsList(params) {
  return request.post('/api/company/news/list', params)
}

/**
 * 获取个人文章列表
 * @param {object} params - { queryStatus, pageNum, pageSize }
 */
export function getMemberNewsList(params) {
  return request.post('/api/member/news/list', params)
}

/**
 * 获取我的留言列表
 * @param {object} params - { pageNum, pageSize }
 */
export function getMemberCommentList(params) {
  return request.post('/api/member/comment/list', params)
}

/**
 * 获取我的收藏列表
 * @param {object} params - { pageNum, pageSize }
 */
export function getMemberFavoriteList(params) {
  return request.post('/api/member/newsFavorite/list', params)
}

/**
 * 获取我的点赞列表
 * @param {object} params - { pageNum, pageSize }
 */
export function getMemberLikeList(params) {
  return request.post('/api/member/newsLike/list', params)
}

/**
 * 删除我的留言
 * @param {object} params - { id }
 */
export function deleteMemberComment(params) {
  return request.post('/api/member/comment/del', params)
}

/**
 * 取消/设置收藏
 * @param {object} params - { newsId, status }
 */
export function toggleFavorite(params) {
  return request.post('/api/member/newsFavorite/favorite', params)
}

/**
 * 取消/设置点赞
 * @param {object} params - { newsId, status }
 */
export function toggleLike(params) {
  return request.post('/api/member/newsLike/like', params)
}
